Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "FeedItem4155780922",
  {"root":"FeedItem4155780922--root","viewer":"FeedItem4155780922--viewer","meta":"FeedItem4155780922--meta","icon":"FeedItem4155780922--icon","reactions":"FeedItem4155780922--reactions","reactionsAndMeta":"FeedItem4155780922--reactionsAndMeta","likeButton":"FeedItem4155780922--likeButton","totalComments":"FeedItem4155780922--totalComments","overlay":"FeedItem4155780922--overlay"},
  "",
  9,
  "FeedItem4155780922"
);

